import { render, staticRenderFns } from "./EditorCarousel.vue?vue&type=template&id=c511f7d6&"
import script from "./EditorCarousel.vue?vue&type=script&lang=js&"
export * from "./EditorCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports